import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
export type OnAccepted = () => void;
export const AcceptTerms = t0 => {
  const $ = _c(14);
  const {
    onAccepted
  } = t0;
  const t = useTranslations("AcceptTerms");
  let t1;
  if ($[0] !== t) {
    t1 = t("description");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="my-1">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onAccepted) {
    t3 = () => onAccepted();
    $[4] = onAccepted;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("accept");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex w-full justify-center"><button className="btn btn-primary" onClick={t3}>{t4}</button></div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <>{t2}{t5}</>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};